"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerMicroTask = void 0;
var internalCallback = null;
var elem = null;
var counter = 1;
if (typeof document !== 'undefined') {
    var observer = new MutationObserver(function () {
        internalCallback === null || internalCallback === void 0 ? void 0 : internalCallback();
        internalCallback = null;
    });
    elem = document.createElement('div');
    observer.observe(elem, { attributes: true });
}
function triggerMicroTask(callback) {
    if (elem) {
        internalCallback = callback;
        elem.setAttribute('data-dui-micro-task', String(counter++));
    }
    else {
        Promise.resolve().then(callback);
    }
}
exports.triggerMicroTask = triggerMicroTask;
